// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"b004bccc","453":"7c3333fe"}[chunkId] + ".chunk.js";
};